import { useRef, useState } from "react";

import Actionbar from "src/components/common/actionbar/Authactionbar";
import LoadingOverlay from "src/components/common/form/LoadingOverlay";
import { Message } from "src/components/common/form/Message";
import { useCommonCodeStore } from "src/store/useCommonCodeStore";

import useUiuxStore from "src/store/useUiuxStore";


import { useMouseContent } from "src/utils/mouse/mouseContent";

import { Content_KSK2090_R01 } from "./Content_KSK2090_R01";
import { SearchSection_KSK2090_R01 } from "./SearchSection_KSK2090_R01";
import { useKSK2090_R01Store } from "./Store_KSK2090_R01";
import { AgGridReact } from "ag-grid-react";
import { KSK2090_R01DetailDto, KSK2090_R01Dto, KSK2090_R01HeaderDto } from "./Dto_KSK2090_R01";
// import { Table_KSK2090_R01 } from "./Table_KSK2090_R01";
import { DetailTable_KSK2090_R01 } from "./DetailTable_KSK2090_R01";


export const Container_KSK2090_R01 = () => {

	const { 
		allCount,
		initData, 
	} = useKSK2090_R01Store();

	const { tabList, setMessage } = useUiuxStore();
	const { KSK2090_R01Filter } = useKSK2090_R01Store();

	const RESIZER = {
		code: 'KSK2090_R01',
		type: 'width',
		storageKey: 'KSK2090_R01-split-width',
		min: 5,
		max: 80,
		default: 35
	} as const;
	const gridRef = useRef<AgGridReact<KSK2090_R01HeaderDto>>(null);
	const detailGridRef = useRef<AgGridReact<KSK2090_R01DetailDto>>(null);

	const containerRef = useRef<HTMLDivElement>(null);
	const infoRef = useRef<HTMLDivElement>(null);
	const isResizing = useRef(false);

	

	const { 
		splitValue,
		handleMouseDown,
		handleMouseUp
	} = useMouseContent({
		resizer: RESIZER,
		isResizing,
		containerRef,
		infoRef
	});

	const {
		handlePrintClick,
		handleExcelClick,
		// fetchData,
		defaultKSK2090_R01DetailRow,
		fetchDetailList,
		initContainerData,
		handleDeleteClick,
		handleCreateClick,
		handleSaveClick,
	} = Content_KSK2090_R01({
		gridRef,
		detailGridRef,
		tabList, setMessage,
		containerRef,
		isResizing,
		
	});

	return <div className={`content-container`}>
		<Actionbar
			onFetchClick={() => fetchDetailList(KSK2090_R01Filter.prntItemcd)}
			onCreateClick={handleCreateClick}
			onDeleteClick={handleDeleteClick}
			onSaveClick={handleSaveClick}
			onPrintClick={handlePrintClick}
			onExcelClick={handleExcelClick}
			onInitClick={initContainerData}
		/>
		<SearchSection_KSK2090_R01 />

		<div className="flex flex-1 p-[12px] gap-[4px] min-h-0"
			ref={containerRef}>
				<div className="h-full w-full">
					{/* 키오스크에서는 피더 abc 수정만 하기때문에 상세테이블만 유지 */}
				<DetailTable_KSK2090_R01 gridRef={detailGridRef} defaultKSK2090_R01DetailRow={defaultKSK2090_R01DetailRow} />
				</div>
		</div>
	</div>
}